export const SERVICES = [
  {
    slug: "deep-tissue-massage",
    path: "/services/deep-tissue-massage",
    name: "Deep Tissue Massage",
    tagline: "Ritual Pressure for Deep Muscular Release",
    metaTitle:
      "Deep Tissue Massage in Ameerpet, Hyderabad | The Soul Skin Spa & Salon",
    metaDescription:
      "Book a deep tissue massage at The Soul Skin Spa & Salon, Ameerpet. Firm therapeutic pressure to dissolve chronic tension and knots. Call +91 7995280296.",
    heroImage:
      "https://images.unsplash.com/photo-1676452471084-032df740321c?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1676452471084-032df740321c?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Firm, deliberate pressure drawn from a heated basalt ritual to dissolve the deepest layers of tension.",
    description:
      "An intensive therapy for guests carrying chronic tension, stiff shoulders or a nagging lower back ache. Our therapists use slow, grounded strokes and sustained pressure — often paired with warm basalt stones — to reach deep muscle layers and release adhesions built up from long hours, intense training, or everyday stress.",
    benefits: [
      "Releases chronic muscular tension & stubborn knots",
      "Improves circulation to overworked muscle groups",
      "Breaks down scar tissue & fascia adhesions",
      "Eases lower back, neck & shoulder stiffness",
      "Restores mobility, flexibility & posture",
    ],
    process: [
      {
        title: "Grounding Welcome",
        text: "A quiet consultation on pressure points and preferred intensity before you settle in.",
      },
      {
        title: "Warm Basalt Glide",
        text: "Heated stones and long strokes prepare the muscles for deeper work.",
      },
      {
        title: "Deep Pressure Ritual",
        text: "Sustained, targeted pressure dissolves knots layer by layer.",
      },
      {
        title: "Still Closure",
        text: "A slow, grounding finish calms the nervous system before you rise.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "thai-massage",
    path: "/services/thai-massage",
    name: "Thai Massage",
    tagline: "Ancient Energy-Line Therapy, Reimagined",
    metaTitle: "Thai Massage in Ameerpet, Hyderabad | The Soul Skin Spa & Salon",
    metaDescription:
      "Experience traditional Thai Massage at The Soul Skin Spa & Salon, Ameerpet — assisted stretching & acupressure along the Sen lines. Call +91 7995280296.",
    heroImage:
      "https://images.unsplash.com/photo-1704211553100-dad83bf34994?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1704211553100-dad83bf34994?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Assisted stretching and rhythmic acupressure along the body's Sen energy lines, grounded in bamboo and water stillness.",
    description:
      "Rooted in centuries-old Thai healing tradition, this therapy blends rhythmic acupressure with assisted, yoga-like stretches performed along the body's Sen energy lines. Practised on a floor mat without oil, it coaxes stiff joints and tight muscles into a greater range of motion while settling an overworked mind into stillness.",
    benefits: [
      "Increases flexibility & joint range of motion",
      "Stimulates energy flow along Sen lines",
      "Relieves stiffness without the use of oils",
      "Calms the nervous system & quiets the mind",
      "Improves posture, balance & circulation",
    ],
    process: [
      {
        title: "Energy Reading",
        text: "We check flexibility, injuries and comfort with assisted stretching.",
      },
      {
        title: "Acupressure Awakening",
        text: "Rhythmic palm & thumb pressure along the Sen lines awakens the body.",
      },
      {
        title: "Guided Stretch Flow",
        text: "Yoga-inspired stretches open the hips, spine and shoulders.",
      },
      {
        title: "Grounded Stillness",
        text: "Slow compressions bring the session to a calm, centred finish.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "full-body-massage",
    path: "/services/full-body-massage",
    name: "Full Body Massage",
    tagline: "A Head-to-Toe Elemental Reset",
    metaTitle:
      "Full Body Massage in Ameerpet, Hyderabad | The Soul Skin Spa & Salon",
    metaDescription:
      "Unwind with a full body massage at The Soul Skin Spa & Salon, Ameerpet — long flowing strokes from head to toe. Call +91 7995280296 to book.",
    heroImage:
      "https://images.unsplash.com/photo-1636714528228-f469eefb3eef?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1636714528228-f469eefb3eef?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "An immersive ritual that moves across the entire body in one continuous, incense-lit sequence.",
    description:
      "A signature Soul Skin ritual that treats the entire body — scalp, neck, back, arms, legs and feet — in one seamless, flowing sequence lit by warm candlelight and gently swirling incense. Long gliding strokes are paired with careful kneading to melt away everyday fatigue, leaving every muscle softened and the mind completely unplugged.",
    benefits: [
      "Full-body stress & fatigue relief",
      "Improved circulation from head to toe",
      "Deep, sustained state of relaxation",
      "Supports better, deeper sleep",
      "Soothes tired feet, legs, back & shoulders",
    ],
    process: [
      {
        title: "Arrival Ritual",
        text: "A quiet welcome with warm light and incense to help you settle.",
      },
      {
        title: "Full Sequence Flow",
        text: "Flowing strokes move systematically from scalp to feet.",
      },
      {
        title: "Pressure Point Focus",
        text: "Extra attention on the back, shoulders and feet — the body's biggest stress holders.",
      },
      {
        title: "Quiet Return",
        text: "A few still minutes to rest before you step back into your day.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "aromatherapy-massage",
    path: "/services/aromatherapy-massage",
    name: "Aromatherapy Massage",
    tagline: "Botanical Alchemy for Mind & Body",
    metaTitle:
      "Aromatherapy Massage in Ameerpet, Hyderabad | The Soul Skin Spa & Salon",
    metaDescription:
      "Relax with an aromatherapy massage at The Soul Skin Spa & Salon using sandalwood, oud & lavender essential oils. Call +91 7995280296 to book.",
    heroImage:
      "https://images.unsplash.com/photo-1636714507452-48716cfa1818?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1636714507452-48716cfa1818?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Therapeutic-grade oils and amber-lit diffusers blended into a fragrant, calming massage ritual.",
    description:
      "A sensory-led therapy pairing gentle, flowing massage strokes with therapeutic-grade essential oils chosen for their calming, mood-balancing properties. As the fragrant blend is worked into the skin beneath the warm glow of amber diffusers, tension dissolves and the mind settles into deep, fragrant calm.",
    benefits: [
      "Reduces anxiety & mental fatigue",
      "Balances mood & emotional wellbeing",
      "Deeply nourishes & softens the skin",
      "Enhances the quality of sleep",
      "A soothing, fragrant sensory escape",
    ],
    oilsMenu: ["Oud", "Sandalwood", "Lavender", "Ylang Ylang"],
    process: [
      {
        title: "Scent Ritual Selection",
        text: "Choose from our curated oil blends based on your mood and needs.",
      },
      {
        title: "Warm Oil Massage",
        text: "Gentle, rhythmic strokes glide the warmed blend across the body.",
      },
      {
        title: "Breath & Stillness Pause",
        text: "Light pauses let the aroma settle, deepening relaxation.",
      },
      {
        title: "Fragrant Afterglow",
        text: "A calm, lingering sense of balance stays with you long after.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
